module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showDetailedView) ? _c('div', {
    staticClass: "cb-field__extend"
  }, [_vm._l((_vm.config_in_twos), function(arr, index) {
    return [(arr.length == 2) ? _c('div', {
      key: index,
      staticClass: "cb-field__group",
      class: [{
        'cb-field--top': index == 0
      }, {
        'cb-field--bottom': (_vm.config_in_twos.length - 1) == index
      }]
    }, [(arr[0].type) ? _c(_vm.componentName(arr[0].type), {
      tag: "component",
      staticClass: "cb-field__left",
      attrs: {
        "sibling-error": _vm.showSiblingError(index, 1),
        "name": arr[0].name
      },
      on: {
        "informError": function($event) {
          _vm.informError(index, 0)
        },
        "clearError": function($event) {
          _vm.clearError(index, 0)
        }
      }
    }) : _vm._e(), _vm._v(" "), (arr[1].type) ? _c(_vm.componentName(arr[1].type), {
      tag: "component",
      staticClass: "cb-field__right",
      attrs: {
        "sibling-error": _vm.showSiblingError(index, 0),
        "name": arr[1].name
      },
      on: {
        "informError": function($event) {
          _vm.informError(index, 1)
        },
        "clearError": function($event) {
          _vm.clearError(index, 1)
        }
      }
    }) : _vm._e()], 1) : (arr.length == 1 && arr[0].type != 'hidden') ? _c('div', {
      key: index,
      staticClass: "cb-field__group",
      class: [{
        'cb-field--top': index == 0
      }, {
        'cb-field--bottom': (_vm.config_in_twos.length - 1) == index
      }]
    }, [(arr[0].type) ? _c(_vm.componentName(arr[0].type), {
      tag: "component",
      attrs: {
        "name": arr[0].name
      },
      on: {
        "place-changed": _vm.fetchResults
      }
    }) : _vm._e()], 1) : _vm._e()]
  })], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e467b0d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/hosted-pages/AddressComponent.vue
// module id = 113
// module chunks = 65 66 67 68